import * as types from "../../actions/companylevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.ADD_DEDUCTION_TAB_SUB_LIST:
      return action.payload.data;

    default:
      return state;
  }
}
